import { renderToString } from 'react-dom/server';
import { ReactBootstrap } from '../../ReactBootstrap';
import type { RewardsListBackendProps } from './types';
import { serializeRewardsListComponentProps } from './utils/serializers';

export function RewardsListRenderer(props: RewardsListBackendProps, document?: Document): string {
  const reactProps = serializeRewardsListComponentProps(props);
  return renderToString(
    <ReactBootstrap
      component="RewardsListComponent"
      props={reactProps}
      document={document}
      componentType="rewards-list"
    />,
  );
}
